import { CogNeedTextField } from '@cogneed/react-utils';
import {
  Box,
  Button,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useProjectInfoContext from '../../../../../../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import ProjectSelector from './ProjectSelector';
import StyledBox from './styles';

interface CreateContentRequestItemProps {
  open: boolean,
  onClose: () => void,
  disableProjectChange?: boolean,
  create: (title: string, details: string, projectId: string) => void,
}

export default function CreateContentRequestItem(props: CreateContentRequestItemProps) {
  const {
    open, onClose, disableProjectChange, create,
  } = props;
  const { project } = useProjectInfoContext();
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('requests');
  const [title, setTitle] = React.useState('');
  const [details, setDetails] = React.useState('');
  const [selectedProject, setSelectedProject] = React.useState({ id: project?.id, name: project?.name });

  if (!open) return null;

  return (
    <StyledBox>
      <Box className="header">
        <ProjectSelector
          disabledProjectChange={disableProjectChange}
          setSelectedProject={setSelectedProject}
          selectedProject={selectedProject}
        />
      </Box>
      <Box className="content">
        <CogNeedTextField value={title} onChange={(e) => { setTitle(e.target.value); }} placeholder={t('create.name-header')} />
        <CogNeedTextField
          fullWidth
          value={details}
          onChange={(e) => { setDetails(e.target.value); }}
          placeholder={t('create.description-header')}
          multiline
          minRows={2}
        />
        <Box className="actions">
          <Button variant="outlined" onClick={onClose}>
            {tCommon('cancel')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (selectedProject.id) {
                create(title, details, selectedProject.id);
              }
            }}
            disabled={!title || !details}
          >
            {tCommon('save')}
          </Button>
        </Box>
      </Box>
    </StyledBox>
  );
}
